import DonNotQualify from './DoNotQualify';

export default DonNotQualify;
